import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../Services/user.service';
import { CommonModule } from '@angular/common';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  providers: [UserService],
})
export class LoginComponent {
  username: string = '';
  password: string = '';
  version: string = '';
  errorMessage: string = '';
  loading = false;

  constructor(private _userservice: UserService, private router: Router) {
    this.version = environment.version;
  }

  loginUser() {
    this.errorMessage = '';
    this.loading = true;
    this._userservice.login(this.username, this.password).subscribe({
      next: (response: any) => {
        this.loading = false;
        if (response) {
          this._userservice.saveToken(response);
          this.router.navigate(['/dashboard']);
        }
      },
      error: (error) => {
        this.loading = false;
        try {
          const parsed = JSON.parse(error.error);
          this.errorMessage = parsed.message ?? 'Login failed. Please try again.';
        } catch {
          this.errorMessage = 'Login failed. Please try again.';
        }
      },
    });
  }
}
